import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './home';
import Tickets from './tickets';
import Schedule from './schedule';
import Exhibitors from './exhibitors';
import Contact from './contact';
import Navbar from '../components/Navbar';
import Footer from '../components/footer';
import Preloader from '../components/Preloader';
import AccessibilityPanel from '../components/AccessibilityPanel';

const Routess = () => {
  return (
    <BrowserRouter>
      <Preloader />
      <a href="#main-content" className="skip-link">Skip to main content</a>
      {/* Navbar renders on every page, outside Routes */}
      <Navbar />

      <div id="main-content">
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/exhibitors" element={<Exhibitors />} />
        <Route path="/contact" element={<Contact />} />
        {/* Add more routes here as you build them */}
        </Routes>
      </div>

      <Footer />
      <AccessibilityPanel />
    </BrowserRouter>
  );
};

export default Routess;
